export const BRAND_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_project-vault-45/artifacts/7vrns14f_WhatsApp%20Image%202026-04-24%20at%2008.28.32.jpeg";

export const LOGIN_BACKGROUND =
  "https://static.prod-images.emergentagent.com/jobs/51dbcc48-bb03-4043-8796-41af70161fb9/images/7c200506e3345cad1a0e299a9b5bd2e7a9970c9b2c432d50fe934761c9b6a0e6.png";

export const PROJECT_STATUSES = [
  { key: "pending", label: "Pending" },
  { key: "in_design", label: "In design" },
  { key: "in_for_planning", label: "In for planning" },
  { key: "in_for_building_control", label: "In for building control" },
  { key: "under_construction", label: "Under construction" },
  { key: "complete", label: "Complete" },
];

export const STATUS_LABELS = {
  pending: "Pending",
  in_design: "In design",
  in_for_planning: "In for planning",
  in_for_building_control: "In for building control",
  under_construction: "Under construction",
  complete: "Complete",
  on_hold: "On hold",
};

export const PROJECT_TYPES = [
  "Commercial",
  "Domestic",
  "Outsourcing",
];

// Maps legacy snake_case contact role values (stored before user-configurable lists)
// to display strings. New contacts store the display string directly.
export const LEGACY_ROLE_LABELS = {
  client: "Client",
  client_representative: "Client Representative",
  contractor: "Contractor",
  structural_engineer: "Structural Engineer",
  planning_consultant: "Planning Consultant",
  quantity_surveyor: "Quantity Surveyor",
  me_consultant: "M&E Consultant",
  approved_inspector: "Approved Inspector",
  other: "Other",
};

export const DOCUMENT_STATUSES = [
  { key: "draft", label: "Draft" },
  { key: "issued_for_information", label: "Issued for information" },
  { key: "issued_for_review", label: "Issued for review" },
  { key: "issued_for_planning", label: "Issued for planning" },
  { key: "issued_for_building_control", label: "Issued for building control" },
  { key: "superseded", label: "Superseded" },
  { key: "final", label: "Final" },
];

export const STATUS_CAPTIONS = {
  pending: "We've received your project brief and are preparing the initial scope.",
  in_design: "Our team is actively working on your design proposals.",
  in_for_planning: "Your application has been submitted to the local planning authority for determination.",
  in_for_building_control: "Building control drawings have been submitted and are under review.",
  under_construction: "Works are in progress on site. We're monitoring progress and issuing any required instructions.",
  complete: "The project has reached practical completion. All documentation has been issued.",
  on_hold: "The project is temporarily paused. We'll be in touch when it resumes.",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "—";
  }
}

export function formatDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

/**
 * formatRelative — short relative timestamp like "12d ago", "2h ago",
 * "just now". Used for at-a-glance freshness indicators on cards.
 */
export function formatRelative(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diffMs = Date.now() - d.getTime();
  if (diffMs < 0) return "just now";
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export const USER_STATUS_LABELS = {
  pending_invite: "Account created",
  invited: "Invite sent",
  active: "Active",
  disabled: "Deactivated",
};

export function userStatusTone(status) {
  switch (status) {
    case "active": return "bg-[rgba(16,185,129,0.1)] text-[#34D399] border-[rgba(16,185,129,0.25)]";
    case "invited": return "bg-[rgba(59,130,246,0.1)] text-[#60A5FA] border-[rgba(59,130,246,0.25)]";
    case "pending_invite": return "bg-[rgba(197,116,66,0.1)] text-[#D98754] border-[rgba(197,116,66,0.25)]";
    case "disabled": return "bg-[rgba(220,38,38,0.08)] text-[#F87171] border-[rgba(220,38,38,0.25)]";
    default: return "bg-white/5 text-[color:var(--atech-text-dim)] border-white/10";
  }
}

export function fileSizeLabel(bytes) {
  if (!bytes) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}
